export default __webpack_public_path__ + "static/media/250.4c02dea5.jpg";